import React, {Component} from "react";
import Table, {TableColumn, TableItem} from "./Table";
import TableCell from "./TableCell";
import {Checkbox} from "office-ui-fabric-react";
import _ from "lodash";

interface MultiSelectTableProps
{
    title?: string;
    columns: TableColumn[];
    loading?: boolean;
    items: TableItem[];
    selectedItems: TableItem[];
    onSelectedItemsChanged: (newSelectedItems: TableItem[]) => void
}

interface MultiSelectTableState
{
    lastCheckedItem?: TableItem; 
}
const selectColumn: TableColumn = {
    title: "",
    propertyPath: "select",
    flex: 1
}

export default class MultiSelectTable extends Component<MultiSelectTableProps,MultiSelectTableState>
{
    constructor(props: Readonly<MultiSelectTableProps>) {
        super(props);
        
        this.state = {
            lastCheckedItem: undefined
        };
    }
    private updateLastChecked = (itemClicked: TableItem, isChecked: boolean) => {
        
        if(isChecked)
        {
            this.setState({
                lastCheckedItem: itemClicked
            });
        }
        else
        {
            this.setState({
                lastCheckedItem: undefined
            });
        }
    }
    private cellForColumn = (item: TableItem,column: TableColumn,columnIndex: number): JSX.Element | undefined => {
        
        if(column == selectColumn)
        {
            const itemIsSelected = this.props.selectedItems.includes(item);
            
            return (
                <TableCell key={columnIndex} flex={column.flex} className={"flex--align-items-flex-end"}>
                    <Checkbox
                        checked={itemIsSelected}
                        onChange={(e, isChecked) => {
                            
                            const nativeEvent = e?.nativeEvent as any;
                            if(nativeEvent.shiftKey && isChecked && this.state.lastCheckedItem)
                            {
                                //select range;
                                const indexes = [this.props.items.indexOf(item), this.props.items.indexOf(this.state.lastCheckedItem)].sort((a, b) => a - b);
                                const start = indexes[0];
                                const end = indexes[1];
                                
                                const itemsToSelect = this.props.items.slice(start,end+1);
                                
                                this.props.onSelectedItemsChanged(_.union(this.props.selectedItems,itemsToSelect));
                                
                                this.updateLastChecked(item,isChecked); //check last checked
                            }
                            else 
                            {
                                // toggle single
                                if(itemIsSelected)
                                {
                                    this.props.onSelectedItemsChanged(_.without(this.props.selectedItems,item));
                                }
                                else
                                {
                                    this.props.onSelectedItemsChanged([...this.props.selectedItems,item]);
                                }
                                this.updateLastChecked(item,isChecked!);
                            }
                        }}
                    />                
                </TableCell>
            );
        }
        
        return undefined;
    }
    public render() {
        return (
            <Table 
                title={this.props.title}
                loading={this.props.loading}
                columns={[...this.props.columns,selectColumn]}
                cellForColumn={this.cellForColumn}
                items={this.props.items}
                enableSort={false}>
                
                {this.props.children}
            </Table>
        );
    }
}
